import { useState, useEffect } from 'react'
import Btn from 'components/btn/btn'
import Form from 'components/form/form'
import Link from 'next/link'
import { getRoute } from 'utils/helpers'
import useApi from 'utils/api'

export default function ResetPassword({ code, withLoginLink, logInAction }) {
    const [step, setStep] = useState(1)
    const api = useApi()

    useEffect(() => {
        setStep(code ? 2 : 1)
    }, [])

    const submitHandler1 = async data => {
        const response = await api.postWithToast('forgot-password', data)
        if (response.status === 200) {
            setStep(2)
        }
    }

    const submitHandler2 = async data => {
        const response = await api.postWithToast('reset-password', data)
        if (response.status === 200) {
            setStep(3)
        }
    }

    const props1 = {
        onSubmit: submitHandler1,
        submitProps: { block: 1 },
        fields: [
            {
                name: 'email',
                type: 'email',
                label: 'Jūsų el. pašto adresas',
                value: '',
                required: true
            }
        ]
    }

    const props2 = {
        onSubmit: submitHandler2,
        submitProps: { block: 1 },
        fields: [
            {
                name: 'code',
                type: 'text',
                label: 'Aktyvavimo kodas',
                required: true,
                value: ''
            },
            {
                name: 'password',
                type: 'password',
                label: 'Naujas slaptažodis',
                required: true,
                value: ''
            }
        ]
    }

    return step === 3 ? (
        <>
            <p className="mb36">Slaptažodis pakeistas. Galite prisijungti.</p>
            {logInAction ? (
                <Btn style="yellow" onClick={logInAction}>
                    Prisijungti
                </Btn>
            ) : (
                <Btn style="yellow" href={getRoute('login')}>
                    Prisijungti
                </Btn>
            )}
        </>
    ) : (
        <>
            {step === 1 ? (
                <Form {...props1} />
            ) : (
                <>
                    <p className="mb24">
                        Jūsų el. pašto adresu išsiustas akvyvavimo kodas. Įveskite jį žemiau esančioje formoje.
                    </p>
                    <Form {...props2} />
                </>
            )}
            {withLoginLink && (
                <footer>
                    <Link href={getRoute('login')}>Atgal į prisijungimą</Link>
                </footer>
            )}
        </>
    )
}
